import positions from '@/data/country-coordinates.json';
import { CountryData } from '@/pages/about';
import Portal from '@reach/portal';
import React, { useMemo } from 'react';
import { isDefined } from 'ts-is-present';
import { Point } from './point';
import { Tooltip, useTooltipContext } from './tooltipContext';

type PointsProps = {
  getTooltip?: (context: Tooltip) => React.ReactNode;
  hasThemeColors?: boolean;
  inStory?: boolean;
  // injected in WorldMap, do not add yourself
  isCenterTile?: boolean;
  // injected in WorldMap, do not add yourself
  tileSize?: number;
  countryData: CountryData[];
};

export function Points({
  countryData,
  getTooltip,
  hasThemeColors,
  isCenterTile,
  tileSize = 480,
}: PointsProps) {
  const { getId, tooltip } = useTooltipContext();

  const points: CountryData[] | undefined = useMemo(() => {
    if (isDefined(countryData)) {
      return countryData
        .map((d) => {
          const position = positions.find((position) => getId(d) === position.id);
          if (isDefined(position)) return { ...d, ...position };
        })
        .filter(isDefined);
    }
  }, [countryData, getId]);

  // radius in % of tileSize
  const radius = ((hasThemeColors ? 5 : 4) / tileSize) * 100;

  return (
    <svg viewBox="0 0 100 100">
      {points &&
        points.map((d) => (
          <Point key={getId(d)} countryData={d} radius={radius} isCenterTile={isCenterTile} />
        ))}

      {isCenterTile && getTooltip && tooltip && <Portal>{getTooltip(tooltip)}</Portal>}
    </svg>
  );
}
